<template>
	<div>
		<mainHead :title="mainHeadTitle" @btnClick="addTableData" :hasPermiDict="hasPermiDict"></mainHead>
		<div class="mianPage">
			<el-form inline class="el-form flex_start">
				<el-form-item label="公司名称：">
					<el-select v-model="queryData.companyName" filterable @change="companyOptionsChange" clearable size="small"
						style="width:210px">
						<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.label">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="APP ID/名称：">
					<el-select v-model="queryData.appId" filterable clearable size="small" style="width:210px">
						<el-option v-for="item in mediaAppOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="广告位ID/名称：">
					<el-input clearable size="small" style="width:210px" placeholder="请输入" v-model="queryData.id"></el-input>
				</el-form-item>
				<el-form-item label="OS：">
					<el-select v-model="queryData.os" clearable size="small" style="width:210px">
						<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.label">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="广告位渠道ID：">
					<el-input clearable size="small" style="width:210px" placeholder="请输入" v-model="queryData.platAdsId"></el-input>
				</el-form-item>
				<el-form-item label="启用状态：">
					<el-select v-model="queryData.status" clearable size="small" style="width:210px">
						<el-option label="启用" :value="1"></el-option>
						<el-option label="停用" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<div class="menu-right">
					<el-button @click="searchReset" size="small" v-hasPermi="['adSpaceManage:adSpaceManage:query']">重置</el-button>
					<el-button type="primary" @click="confirmQuery" size="small" v-hasPermi="['adSpaceManage:adSpaceManage:query']">查询</el-button>
				</div>
			</el-form>
			<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
				class="el_table">
				<el-table-column prop="os" label="操作系统" width="150"></el-table-column>
				<el-table-column prop="companyName" label="公司名称"></el-table-column>
				<el-table-column prop="" label="所属应用/ID">
					<template slot-scope="scope">
						<div >{{scope.row.appName}}/{{scope.row.appId}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="广告类型">
					<template slot-scope="scope">
						<div >{{scope.row.typeValue}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="广告位ID">
					<template slot-scope="scope">
						<div >{{scope.row.name}}/{{scope.row.id}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="删除状态">
					<template slot-scope="scope">
						<div v-if="scope.row.isDeleted == -1">已删除</div>
						<div v-else-if="scope.row.isDeleted !== -1">未删除</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="启用状态">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.status" @change="adSwitchChange($event,scope.row)"
						:active-value="1" :inactive-value="0" :disabled="scope.row.isDeleted == -1"></el-switch>
					</template>
				</el-table-column>
				<el-table-column prop="" label="操作" fixed="right" width="150">
					<template slot-scope="scope">
						<el-button type="text" @click="editTable(scope.row,scope.$index)" v-hasPermi="['adSpaceManage:adSpaceManage:edit']"
						:disabled="scope.row.isDeleted == -1">编辑</el-button>
						<el-button type="text" @click="channelManage(scope.row)" v-hasPermi="['adSpaceManage:adSpaceManage:config']"
						:disabled="scope.row.isDeleted == -1">配置</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
				<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="currentPage"
					:page-sizes="[10, 20, 30, 500]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="广告位信息" :visible.sync="dialogVisible" width="28%" :close-on-click-modal="false">
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="adRulesApi" :model="mediaADFormData"
				ref="ruleMediaForm">
				<el-form-item label="所属应用：">
					<el-select v-model="mediaADFormData.appId" filterable clearable size="small" :disabled="isAdEditDialog">
						<el-option v-for="item in mediaAppOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="广告类型：">
					<el-select v-model="mediaADFormData.type" clearable size="small" :disabled="isAdEditDialog">
						<el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="广告样式：" v-if="isAdEditDialog">
					<el-select v-model="mediaADFormData.style" clearable size="small" :disabled="isAdEditDialog">
						<el-option v-for="item in adStyleOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="广告位名称：" prop="name">
					<el-input clearable size="small" placeholder="请输入" v-model="mediaADFormData.name"></el-input>
				</el-form-item>
				<el-form-item label="加载广告：" v-if="isAdEditDialog">
					<el-select v-model="mediaADFormData.loadTypeId" clearable size="small">
						<el-option v-for="item in loadTypeSelectData" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="计数点：" prop="" v-if="isAdEditDialog">
					<el-input clearable size="small" placeholder="请输入" v-model="mediaADFormData.countPoint"></el-input>
				</el-form-item>
				<div class="card-bottom flex_end">
					<el-button @click="closeMediaDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmMedia('ruleMediaForm')" size="medium">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
		<el-drawer @close="closeDrawer" :visible.sync="companyDrawerShow" size="70%" :wrapperClosable="true"
			:with-header="false" border="none">
			<div class="box-card">
				<div class="cardTitle space_between">
					<div class="cardTitleTxt">广告位配置-{{adConfigForm.name}}-{{adConfigForm.appName}}</div>
					<i class="el-icon-circle-close" @click="companyDrawerShow=false"></i>
				</div>
				<div class="cardContent">
					<div class="menu-right flex_end">
						<el-button type="primary" @click="addAdGroup" size="small">新增分组</el-button>
					</div>
					<el-table :header-cell-style="{color:'#333333',background:'#EAEFF5'}"
						:data="adConfigTableData" class="el_table drawerTable" default-expand-all>
						<el-table-column type="expand">
							<template slot-scope="props">
								<el-table :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="props.row.adsPlatList"
									class="el_table">
									<el-table-column prop="platAdsId" label="渠道">
										<template slot-scope="scope">
											<el-select v-model="scope.row.platformId" clearable size="small">
												<el-option v-for="item in platAdsOptions" :key="item.value" :label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</template>
									</el-table-column>
									<el-table-column prop="level" label="优先级" width="180">
										<template slot-scope="scope">
											<el-input-number size="small" :min="1" :max="9999" label="优先级" v-model="scope.row.level"></el-input-number>
										</template>
									</el-table-column>
									<el-table-column prop="platAdsName" label="广告位名称">
										<template slot-scope="scope">
											<el-input clearable size="small" placeholder="广告位名称" v-model="scope.row.platAdsName"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="platAdsId" label="广告位渠道ID">
										<template slot-scope="scope">
											<el-input clearable size="small" placeholder="广告位渠道ID" v-model="scope.row.platAdsId"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="notifySecret" label="平台回调secret">
										<template slot-scope="scope">
											<el-input clearable size="small" placeholder="平台回调secret" v-model="scope.row.notifySecret"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="priceFloorDou" label="底价(元)">
										<template slot-scope="scope">
											<el-input clearable size="small" placeholder="底价(元)" v-model="scope.row.priceFloorDou"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="divideRatio" label="分成">
										<template slot-scope="scope">
											<el-input clearable size="small" placeholder="分成" v-model="scope.row.divideRatio"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="status" label="启用状态" width="90">
										<template slot-scope="scope">
											<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"></el-switch>
										</template>
									</el-table-column>
									<el-table-column prop="" label="操作" width="90">
										<template slot-scope="scope">
											<!-- <el-button type="text" @click="editChannel(scope.row,scope.$index)">编辑</el-button> -->
											<el-button type="text" @click="deleteAdRow(props.row,scope.row,scope.$index)">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</el-table-column>
						<el-table-column prop="groupDou" label="Biding" width="200"></el-table-column>
						<el-table-column prop="timeout" label="请求时长" width="300">
							<template slot-scope="scope">
								<el-input clearable size="small" placeholder="请求时长" v-model="scope.row.timeout"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="" label="操作">
							<template slot-scope="scope">
								<el-button type="text" @click="addAdRow(scope.row,scope.$index)">新增广告</el-button>
								<!-- <el-button type="text" @click="deleteAdGroup(scope.row,scope.$index)">删除分组</el-button> -->
							</template>
						</el-table-column>
					</el-table>
					<el-table :header-cell-style="{color:'#333333',background:'#EAEFF5'}"
						:data="adConfigTableDatas" class="el_table drawerTable" default-expand-all>
						<el-table-column type="expand">
							<template slot-scope="props">
								<el-table :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="props.row.adsPlatList"
									class="el_table">
									<el-table-column prop="platAdsId" label="渠道">
										<template slot-scope="scope">
											<el-select v-model="scope.row.platformId" clearable size="small">
												<el-option v-for="item in platAdsOptions" :key="item.value" :label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</template>
									</el-table-column>
									<el-table-column prop="level" label="优先级" width="180">
										<template slot-scope="scope">
											<el-input-number size="small" :min="1" :max="9999" label="优先级" v-model="scope.row.level"></el-input-number>
										</template>
									</el-table-column>
									<el-table-column prop="platAdsName" label="广告位名称">
										<template slot-scope="scope">
											<el-input clearable size="small" placeholder="广告位名称" v-model="scope.row.platAdsName"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="platAdsId" label="广告位渠道ID">
										<template slot-scope="scope">
											<el-input clearable size="small" placeholder="广告位渠道ID" v-model="scope.row.platAdsId"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="notifySecret" label="平台回调secret">
										<template slot-scope="scope">
											<el-input clearable size="small" placeholder="平台回调secret" v-model="scope.row.notifySecret"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="priceFloorDou" label="底价(元)">
										<template slot-scope="scope">
											<el-input clearable size="small" placeholder="底价(元)" v-model="scope.row.priceFloorDou"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="divideRatio" label="分成">
										<template slot-scope="scope">
											<el-input clearable size="small" placeholder="分成" v-model="scope.row.divideRatio"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="status" label="启用状态" width="90">
										<template slot-scope="scope">
											<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"></el-switch>
										</template>
									</el-table-column>
									<el-table-column prop="" label="操作" width="90">
										<template slot-scope="scope">
											<!-- <el-button type="text" @click="editChannel(scope.row,scope.$index)">编辑</el-button> -->
											<el-button type="text" @click="deleteAdRowNoBiding(props.row,scope.row,scope.$index)">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</el-table-column>
						<el-table-column prop="groupDou" label="非Biding" width="200"></el-table-column>
						<el-table-column prop="timeout" label="请求时长" width="300">
							<template slot-scope="scope">
								<el-input clearable size="small" placeholder="请求时长" v-model="scope.row.timeout"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="" label="操作">
							<template slot-scope="scope">
								<el-button type="text" @click="addAdRowNoBiding(scope.row,scope.$index)">新增广告</el-button>
								<el-button type="text" @click="deleteAdGroupNoBiding(scope.row,scope.$index)">删除分组</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="card-bottom flex_end">
						<el-button @click="companyDrawerShow=false" size="medium">取消</el-button>
						<el-button type="primary" @click="confirmADConfig()" size="medium">确定</el-button>
					</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import { number } from 'echarts';
	export default {
		data() {
			return {
				mainHeadTitle: '广告位管理',
				hasPermiDict: 'adSpaceManage:adSpaceManage:add',
				companyDrawerShow: false,
				handleSelection: "", // 存储ID
				datePicker: [],
				adTypeSelectData: [],
				loadTypeSelectData: [], // 加载类型拉下列表
				osOptions: [], // OS下拉选择列表
				companyOptions: [], // 公司下拉选择列表
				mediaAppOptions: [], // 媒体APP下拉选择列表
				adTypeOptions: [], // 广告类型下拉选择
				adStyleOptions: [], // 广告样式下拉选择
				platAdsOptions: [], //广告平台下拉选择
				queryData: {
					appId: ''
				},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				rulesApi: {
					companyName: [ //公司名称
						{
							required: true,
							message: '必填项，请输入',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 50,
							message: '长度在 1 到 50 个字符',
							trigger: 'blur'
						}
					],
					nickName: [ //公司地址
						{
							required: true,
							message: '请输入公司简称',
							trigger: 'blur'
						},
					],
				},
				adRulesApi: {
					name: [{required: true,message: '请输入广告位名称',trigger: 'blur'}],
				},
				mediaADFormData: {}, // 媒体广告位表单数据
				adConfigForm: {}, // 广告位配置数据

				dialogVisible: false, // 弹框显隐
				isAdEditDialog: false, //广告弹框是否编辑
				adConfigTableData: [], // 广告位配置表格数据
				adConfigTableDatas: [],
			}
		},
		activated(){
			this.getMediaAppOption();
			this.$nextTick(()=>{
				this.getTableData();
			})
		},
		mounted() {
			this.getOSOption();
			this.getCompanyOption();
			this.getADTypeOption();
			this.getADStyleOption();
		},
		methods: {
			companyOptionsChange() {},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			// 获取OS下拉列表
			async getOSOption() {
				let res = await this.$http.get(this.$api.common.osOption);
				this.osOptions = res.data
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption() {
				let res = await this.$http.get(this.$api.common.mediaAppOptionFilter);
				this.mediaAppOptions = res.data
				if (this.$route.query.appId) {
					this.$nextTick(() => {
						this.queryData.appId = this.$route.query.appId
						this.getTableData();
					})
				}
			},
			// 获取广告类型下拉列表
			async getADTypeOption() {
				let res = await this.$http.get(this.$api.common.adTypeOption);
				this.adTypeOptions = res.data
			},
			// 获取广告样式下拉列表
			async getADStyleOption() {
				let res = await this.$http.get(this.$api.common.adStyleOption);
				this.adStyleOptions = res.data
			},
			// 获取广告平台下拉列表
			async getPlatAdsOption(appId) {
				let data = {appId:appId}
				let res = await this.$http.get(this.$api.common.platAdsOption,data);
				this.platAdsOptions = res.data
			},
			// 获取加载类型下拉列表
			async getloadTypeSelectData(appId){
				let data = {appId:appId}
				let res = await this.$http.get(this.$api.common.mediaAdsOption,data);
				this.loadTypeSelectData = res.data
			},
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize
				}
				data = {...data,...this.queryData}
				let res = await this.$http.post(this.$api.mediaAd.adsList, data);
				this.tableData = res.data.list
				this.total = res.data.totalRecord
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			// 新增表格信息
			addTableData() {
				this.$router.push({
					path: '/adSpaceEdit',
					query: {
						sideId: 3
					}
				})
				// this.mediaADFormData = {}
				// this.isAdEditDialog = false
				// this.dialogVisible = true
			},
			// 编辑表格信息
			editTable(row, index) {
				// this.mediaADFormData = row
				// this.getloadTypeSelectData(row.appId)
				// this.isAdEditDialog = true
				// this.dialogVisible = true
				this.$router.push({
					path: '/adSpaceEdit',
					query: {
						sideId: 3,
						id: row.id,
						appId: row.appId
					}
				})
			},
			// 表格弹窗关闭
			closeMediaDialog() {
				this.dialogVisible = false
			},
			// 媒体信息编辑确认
			confirmMedia(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.mediaADFormData;
						if(data.id){
							let res = await this.$http.post(this.$api.mediaAd.adsEdit, data);
							if(res.code ==1 ){
								this.$message.success('修改成功');
							}
						}else{
							let res = await this.$http.post(this.$api.mediaAd.adsAdd, data);
							if(res.code ==1 ){
								this.$message.success('新增成功');
							}
						}
						this.closeMediaDialog();
						this.getTableData();
					}
				});
			},
			closeDrawer() {
				this.companyDrawerShow = false
			},
			async channelManage(row) {
				// console.log(row)
				this.adConfigForm = JSON.parse(JSON.stringify(row))
				this.getPlatAdsOption(row.appId)
				if(row.bidingPlatAdsList&&row.bidingPlatAdsList.length>0){
					this.adConfigTableData = row.bidingPlatAdsList
				}else{
					this.adConfigTableData = [
						{
							groupDou: 0,
							timeout: 3000,
							adsPlatList: [],
						}
					]
				}
				if(row.platAdsList&&row.platAdsList.length>0){
					this.adConfigTableDatas = row.platAdsList
				}else{
					this.adConfigTableDatas = []
				}
				this.companyDrawerShow = true
			},
			async confirmADConfig() {
				let data = {
					adsId: this.adConfigForm.id,
					appId: this.adConfigForm.appId,
					platAdsInfoList: []
				};
				let adTables = []
				let obj = {}
				console.log(this.adConfigTableData)
				if(this.adConfigTableData.length > 0){
					for(let i=0;i<this.adConfigTableData.length;i++){
						for(let j=0;j<this.adConfigTableData[i].adsPlatList.length;j++){
							obj['timeout'] = this.adConfigTableData[i].timeout
							// console.log(obj,this.adConfigTableData[i].adsPlatList[j])
							obj = {...obj,...this.adConfigTableData[i].adsPlatList[j]}
							obj['groupDou'] = this.adConfigTableData[i].adsPlatList[j].priceFloorDou
							obj['group'] = this.adConfigTableData[i].adsPlatList[j].priceFloorDou * 1
							// obj['groupId'] = this.adConfigTableData[i].groupId
							obj['indexId'] = i
							obj['key'] = j
							// console.log(obj.groupDou)
							adTables.push(obj)
							obj = {}
						}
					}
					// console.log(adTables)
					data.platAdsInfoList = adTables
				}
				let adsTables = []
				let objs = []
				if(this.adConfigTableDatas.length > 0){
					for(let i=0;i<this.adConfigTableDatas.length;i++){
						for(let j=0;j<this.adConfigTableDatas[i].adsPlatList.length;j++){
							objs['timeout'] = this.adConfigTableDatas[i].timeout
							obj['key'] = j
							objs = {...objs,...this.adConfigTableDatas[i].adsPlatList[j]}
							objs['groupDou'] = this.adConfigTableDatas[i].adsPlatList[j].priceFloorDou
							objs['group'] = this.adConfigTableDatas[i].adsPlatList[j].priceFloorDou * 1
							obj['groupId'] = this.adConfigTableDatas[i].groupId||''
							objs['indexId'] = i
							adsTables.push(objs)
							objs = {}
						}
					}
					// console.log(adsTables)
					data.platAdsInfoList = data.platAdsInfoList.concat(adsTables)
				}
				data.platAdsInfoList.map(item=>{
					if(item.priceFloorDou){
						item['priceFloor'] = (item.priceFloorDou * 1) * 100
					}
					if(item.groupDou){
						item['group'] = (item.groupDou * 1) * 100
					}
				})
				// console.log(data.platAdsInfoList)
				let res = await this.$http.post(this.$api.mediaAd.adsConfigEdit, data);
				if(res.code ==1 ){
					this.$message.success('配置成功');
				}
				this.closeDrawer();
				this.getTableData();
			},
			// 广告位配置新增分组
			addAdGroup() {
				let obj = {
					groupDou: 0,
					timeout: 3000,
					adsPlatList: [],
					groupId: null
				}
				this.adConfigTableDatas.push(obj)
			},
			// 广告位配置删除分组
			deleteAdGroup(row, index) {
				this.adConfigTableData.splice(index, 1)
			},
			// 广告位配置新增行
			addAdRow(row,index){
				let obj = {
					bidding: 2,
					id: 0,
					platAdsId: '',
					level: 0,
					platAdsName: '',
					notifySecret: '',
					priceFloorDou: '',
					divideRatio: '1',
					// groupId: row.groupId,
					status: 0,
				}
				row.adsPlatList.push(obj)
			},
			// 广告位配置删除行
			deleteAdRow(props,row, index){
				props.adsPlatList.splice(index, 1)
			},
			addAdRowNoBiding(row,index){
				let obj = {
					bidding: 1,
					id: 0,
					platAdsId: '',
					level: 0,
					platAdsName: '',
					notifySecret: '',
					priceFloorDou: '',
					divideRatio: '1',
					groupId: row.groupId,
					status: 0,
				}
				row.adsPlatList.push(obj)
			},
			deleteAdGroupNoBiding(row, index){
				this.adConfigTableDatas.splice(index, 1)
			},
			deleteAdRowNoBiding(props,row, index){
				props.adsPlatList.splice(index, 1)
			},
			// 广告位状态修改
			async adSwitchChange(e,row){
				let data = {
					adsId: row.id,
					status: e
				}
				let res = await this.$http.get(this.$api.mediaAd.adsStatus, data);
				if(res.code == 1){
					this.$message.success('状态修改成功');
				}
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		margin: 20px;
		background: #FFFFFF;
		border-radius: 4px;
		padding: 24px;
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}

	.menu-right {
		margin-left: auto;
		margin-top: 4px;
		margin-bottom: 22px;
	}

	.cardTitle {
		font-weight: 500;
		padding: 18px 20px;
		border-bottom: 1px solid #EBEEF5;
		box-sizing: border-box;
		font-size: 22px;
		color: #000000;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100vh;
		overflow-y: auto;
	}
	.cardContent{
		padding: 20px;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}
	.el-drawer__body{
		/* overflow-y: auto; */
	}
	.box-card /deep/ .el-card__body{
		height: 84%;
		overflow-y: scroll;
		box-sizing: border-box;
	}

	.card-bottom {
		padding-right: 30px;
		/* position: fixed;
		bottom: 50px;
		right: 50px; */
	}
	
	.el_table /deep/.el-table__expanded-cell{
		padding: 20px !important;
	}




	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}

	.drawerTable {
		margin: 20px 0;
		/* padding: 10px; */
		box-sizing: border-box;
	}

	.box-card /deep/ .el-card__body {
		/* box-sizing: border-box; */
	}
	/* .el-drawer.rtl{
	  overflow: scroll;
	} */
</style>